import { Agent } from "@/types/app/agent";
import { AttributeDetails } from "./AttributeDetails";
import { JsonSchemaDetails } from "./PromptDetails/JsonSchemaDetails";
import { ParametersDetails } from "./AgentDetails/ParametersDetails";
import { TemplateDetails } from "./PromptDetails/TemplateDetails";
import { ToolDetails } from "./AgentDetails/ToolDetails";

export const AgentVersionDetails = ({ version }: { version: Agent }) => {
  return (
    <div>
      <ParametersDetails {...version} />
      <TemplateDetails template={version.template} template_language={version.template_language} />
      <ToolDetails tools={version.tools} />
      <JsonSchemaDetails response_format={version.response_format} />
      <AttributeDetails {...version} />
    </div>
  );
};
